(function () {
  const mq = window.matchMedia('(max-width: 1023px)');
  let frameId = null;
  const borderClasses = ['grid-border-right', 'grid-border-bottom'];

  function reorder(list) {
    list.querySelectorAll('.collection-grid-image-card--wide').forEach(function (wide) {
      if (wide.dataset.collectionImagesReordered === 'true') return;

      var prev = wide.previousElementSibling;
      if (!prev) return;

      list.insertBefore(wide, prev);
      wide.dataset.collectionImagesReordered = 'true';
    });
  }

  function restore(list) {
    list.querySelectorAll('.collection-grid-image-card--wide').forEach(function (wide) {
      if (wide.dataset.collectionImagesReordered !== 'true') return;

      var next = wide.nextElementSibling;
      if (!next) return;

      list.insertBefore(next, wide);
      delete wide.dataset.collectionImagesReordered;
    });
  }

  function syncList(list) {
    if (mq.matches) {
      reorder(list);
    } else {
      restore(list);
    }
  }

  function getColumnCount(list) {
    const computed = window.getComputedStyle(list);
    const columnCount = parseInt(computed.getPropertyValue('--col-number'), 10);

    if (columnCount > 0) return columnCount;

    const columns = computed.gridTemplateColumns;
    if (!columns || columns === 'none') return 1;

    return columns.split(' ').filter(Boolean).length || 1;
  }

  function getItemSpan(item, columnCount) {
    if (!item.classList.contains('collection-grid-image-card--wide')) return 1;

    return mq.matches ? columnCount : Math.min(2, columnCount);
  }

  function applyGridBorders(list) {
    const items = Array.prototype.filter.call(list.children, function (item) {
      return item.classList.contains('f-column');
    });
    const columnCount = getColumnCount(list);
    const placements = [];
    let row = 1;
    let column = 1;
    let lastRow = 1;

    items.forEach(function (item) {
      const span = Math.max(1, Math.min(getItemSpan(item, columnCount), columnCount));

      if (column > 1 && column + span - 1 > columnCount) {
        row += 1;
        column = 1;
      }

      const placement = {
        item: item,
        row: row,
        columnEnd: column + span - 1,
      };

      placements.push(placement);
      lastRow = Math.max(lastRow, row);

      column += span;
      if (column > columnCount) {
        row += 1;
        column = 1;
      }
    });

    items.forEach(function (item) {
      item.classList.remove.apply(item.classList, borderClasses);
    });

    placements.forEach(function (placement) {
      placement.item.classList.toggle('grid-border-right', placement.columnEnd < columnCount);
      placement.item.classList.toggle('grid-border-bottom', placement.row < lastRow);
    });
  }

  function syncAll() {
    frameId = null;

    document.querySelectorAll('.products-list.collection-images').forEach(function (list) {
      syncList(list);
    });

    document.querySelectorAll('.products-list.grid-borders').forEach(function (list) {
      applyGridBorders(list);
    });
  }

  function scheduleSync() {
    if (frameId) cancelAnimationFrame(frameId);
    frameId = requestAnimationFrame(syncAll);
  }

  function shouldSyncNode(node) {
    if (node.nodeType !== 1) return false;

    return (
      node.matches('.products-list.collection-images, .products-list.grid-borders, .f-column') ||
      node.querySelector('.products-list.collection-images, .products-list.grid-borders, .f-column')
    );
  }

  function observeGrid() {
    const container = document.getElementById('ProductGridContainer');
    if (!container || !window.MutationObserver) return;

    const observer = new MutationObserver(function (mutations) {
      const shouldSync = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes, shouldSyncNode);
      });

      if (shouldSync) scheduleSync();
    });

    observer.observe(container, { childList: true, subtree: true });
  }

  mq.addEventListener('change', scheduleSync);
  window.addEventListener('resize', scheduleSync);
  document.addEventListener('collection:rerendered', scheduleSync);
  document.addEventListener('click', function (event) {
    if (event.target instanceof Element && event.target.closest('layout-switcher button')) scheduleSync();
  });

  observeGrid();
  scheduleSync();
})();
